// Approval codes (owner, Oct 29 2026): the owner's switches (which sensitive POS
// actions need an owner's / manager's approval code; all off by default) and each
// approver's own code. Backend: routes/approval_codes.py -> services/approval_codes
// (the gate every action's server door calls: security/approval_gate).
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL || '';
const BASE = `${API}/api/rest/v1/approval-codes`;

const auth = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const getApprovalCodes = (token) => axios.get(BASE, auth(token)).then((r) => r.data);
export const saveSwitches = (token, actions) => axios.put(`${BASE}/settings`, { actions }, auth(token)).then((r) => r.data);
export const setApprovalCode = (token, person, code) =>
  axios.put(`${BASE}/codes/${encodeURIComponent(person)}`, { code }, auth(token)).then((r) => r.data);
export const removeApprovalCode = (token, person) =>
  axios.delete(`${BASE}/codes/${encodeURIComponent(person)}`, auth(token)).then((r) => r.data);
export const approvalHistory = (token) => axios.get(`${BASE}/history`, auth(token)).then((r) => r.data.events || []);

export const ROLE_WORDS = {
  owner: 'Owner', manager: 'Manager', supervisor: 'Supervisor', cashier: 'Cashier', waiter: 'Server',
  host: 'Host', kitchen: 'Kitchen', expo: 'Expo',
};

// The server's answer as words (a string detail, or a detail object's message)
export function errorWords(error, fallback) {
  const d = error?.response?.data?.detail;
  if (typeof d === 'string' && d) return d;
  if (d && typeof d.message === 'string') return d.message;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg;
  return fallback;
}

// 4-6 digits, typed on a keypad
export const validCode = (code) => /^\d{4,6}$/.test(String(code || ''));
